import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Col, Row } from 'antd';
import Button from 'components/Button';
import { getOptions, plugin, handleDownloadImage } from './GraficoPizza';

ChartJS.register(CategoryScale, LinearScale, ArcElement, Tooltip, Legend, ChartDataLabels);

const GraficoPizzaGenerico = ({ dados, height, width, margin, title = '', exportar = false }) => {
  let ref = useRef(null);

  const options = getOptions(title);

  const downloadImage = useCallback(() => {
    handleDownloadImage(title, ref);
  }, [title]);

  return (
    <>
      {exportar && (
        <Row flex justify="end">
          <Col>
            <Button text={'Exportar Gráfico'} clickAction={downloadImage} />
          </Col>
        </Row>
      )}
      <div
        id="GraficoPizzaComponente"
        data-testid="GraficoPizzaComponente"
        style={{ height: height, width: width, margin: margin, display: 'table' }}
      >
        <Pie ref={ref} id="GraficoPizzaComponenteCanva" data={dados} options={options} plugins={[plugin]} />
      </div>
    </>
  );
};

GraficoPizzaGenerico.propTypes = {
  dados: PropTypes.object,
  height: PropTypes.string,
  width: PropTypes.string,
  margin: PropTypes.string,
  title: PropTypes.string,
  exportar: PropTypes.bool,
};

GraficoPizzaGenerico.defaultProps = {
  // dados: {},
  // height: '',
  // width: '',
  // margin: '',
  // title: '',
  // exportar: false,
};

export default GraficoPizzaGenerico;
